"use client"

import Script from 'next/script'

export default function Cookiebot() {

  return (
    <>
      <Script 
        id="Cookiebot" 
        src="https://consent.cookiebot.com/uc.js" 
        data-cbid="3610b487-dca9-4164-8d8a-48ca04b13a99" 
        data-blockingmode="auto" 
        type="text/javascript" />
    </>
  )
}
